import { render } from "./carousel-slide.vue?vue&type=template&id=8dd5ad04"
import script from "./carousel-slide.vue?vue&type=script&lang=js"
export * from "./carousel-slide.vue?vue&type=script&lang=js"

import "./carousel-slide.vue?vue&type=style&index=0&id=8dd5ad04&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__